import React from 'react';
import QueryItem from '../components/query_term.js';
import SearchBar from '../components/search_bar.js';
import { QueryListStyle} from '../styles/query_list_styles.js';
import '../styles/transitional_query.css';

const QueryContainer = (props) => {

  const queryItems = props.data.terms.map((term, ndx) => {
    return (
          <QueryItem
          props={props}
          onQuerySelect= {props.onQuerySelect}
          updateHoverState= {props.updateHoverState}
          disableHover= {props.disableHover}
          key= {ndx}
          ndx= {ndx}
          term= {term.text}
          color= {term.color}
          />
        );
    });
      return(
        <QueryListStyle>
          {queryItems}
          <SearchBar props={props} searchQuery={props.searchQuery} />
        </QueryListStyle>
      )

}

export default QueryContainer;
